import { onlyNumbers } from 'services/number'

/**
 * sendMessageWhatsapp - send a message through the whatsapp app
 * @param {string} telephone
 * @param {string} message
 */
export const sendMessageWhatsapp = (telephone, message) => {
  const whatsappMessage = encodeURIComponent(message)
  const url = `https://wa.me/${onlyNumbers(telephone)}?text=${whatsappMessage}`

  makeAnAnchor(url, openExternalLinkInDesktop())
}

/**
 * mobilCallPhone - start the mobile app to call the phone number
 * @param {string} telephone
 */
export const mobilCallPhone = telephone => {
  const url = `tel:${telephone}`

  makeAnAnchor(url)
}

/**
 * sendEmail
 * @param {String} email
 * @param {Object} config
 */

export const sendEmail = (email, config = {}) => {
  const url = `mailto:${email}?Subject=${config.subject || ''}&&body=${config.message || config.body || ''}`

  makeAnAnchor(url, openExternalLinkInDesktop())
}

export const makeAnAnchor = (url, attributes = []) => {
  const element = document.createElement('a')

  attributes.forEach(att => {
    const [key] = Object.keys(att)
    element.setAttribute(key, att[key])
  })

  element.setAttribute('href', url)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

const openExternalLinkInDesktop = () => {
  const attributes = []

  if(!isMobileDebice()) {
    attributes.push({ target: '_blank' })
  }

  return attributes
}

export const isMobileDebice = () => {
  // Solution from https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
  const currentAgent = navigator.userAgent || navigator.vendor || window.opera
  const firstRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
  const secondRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i

  return (
    firstRegex.test(currentAgent) || secondRegex.test(currentAgent.substr(0, 4))
  )
}
